import { render, staticRenderFns } from "./SideNavMobile.vue?vue&type=template&id=8137c77a&scoped=true&"
import script from "./SideNavMobile.vue?vue&type=script&lang=js&"
export * from "./SideNavMobile.vue?vue&type=script&lang=js&"
import style0 from "./SideNavMobile.vue?vue&type=style&index=0&id=8137c77a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8137c77a",
  null
  
)

export default component.exports